import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { createRole } from "../action/role";
import { toast } from "react-toastify";
import validator from "validator";

const CreateRoleDetailsModal = ({ show, onClose, onSuccess }) => {
  const [roleName, setRoleName] = useState("");
  const [desc, setDesc] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validateForm = () => {
    let newErrors = {};

    if (!validator.trim(roleName || "")) {
      newErrors.roleName = "Role name is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleCreate = async () => {
    try {
      if (!validateForm()) return;

      setLoading(true);

      const payload = {
        name: roleName,
        description: desc,
        user_access_levels: [],
      };

      const res = await createRole(payload);
      if (res.status) {
        toast.success("Role created successfully");
        setRoleName("");
        setDesc("");
        setErrors({});
        onClose();
        if (onSuccess) onSuccess();
      } else {
        toast.error(res.message || "Failed to create role");
      }
    } catch (error) {
      console.log("Error creating role", error);
      toast.error("Failed to create role");
    } finally {
      setLoading(false);
    }
  };

  const handleModalClose = () => {
    setRoleName("");
    setDesc("");
    setErrors({});
    onClose();
  };

  return (
    <Modal show={show} onHide={handleModalClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Create New Role</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="frm-group">
          <label className="frm-label">Role Name</label>
          <input
            type="text"
            className="frm-input"
            value={roleName}
            onChange={(e) => setRoleName(e.target.value)}
            placeholder="Enter role name"
          />
          {errors.roleName && (
            <div className="text-danger mt-1">{errors.roleName}</div>
          )}
        </div>

        <div className="frm-group">
          <label className="frm-label">Description</label>
          <textarea
            rows={3}
            className="frm-input"
            value={desc}
            onChange={(e) => setDesc(e.target.value)}
            placeholder="Enter role description"
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn-white"
          onClick={handleModalClose}
          disabled={loading}
        >
          Cancel
        </button>
        <button
          className="btn-black"
          onClick={handleCreate}
          disabled={loading}
        >
          {loading ? "Creating..." : "Create"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateRoleDetailsModal;
